import { render, staticRenderFns } from "./recommended-listing-btn.vue?vue&type=template&id=7036c916&scoped=true"
import script from "./recommended-listing-btn.vue?vue&type=script&lang=js"
export * from "./recommended-listing-btn.vue?vue&type=script&lang=js"
import style0 from "./recommended-listing-btn.vue?vue&type=style&index=0&id=7036c916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036c916",
  null
  
)

export default component.exports